var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.journal_task_status",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.TASK_STATUS_NAMES[item.journal_task_status]))])]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [(_vm.isPassButtonVisible(item.journal_task_status))?_c('v-btn',{attrs:{"to":{
        name: 'TaskPass',
        params: { id: item.task_id },
        query: { groupId: _vm.$route.params.groupId },
      },"color":"success","rounded":""}},[_vm._v("Пройти")]):_vm._e()]}},{key:"item.comment",fn:function(ref){
      var item = ref.item;
return [_c('sdo-dialog',{attrs:{"button-options":{ label: 'Показать', color: 'success', text: 'text' }},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Комментарий к заданию")]},proxy:true},{key:"body",fn:function(){return [_vm._v(_vm._s(item.comment))]},proxy:true}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }